import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'

import { SelectElement } from '../components/selectElement'
import LoadingOverlay from '../components/LoadingOverlay'
import { NoAcceso } from '../components/NoAcceso'



const pasarMayusculas= (ev) =>{
    ev.preventDefault();
    ev.target.defaultValue= ev.target.defaultValue.toUpperCase();
    ev.target.value= ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);

const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
    
const sweetConfirm = ( title, html, icon ) =>{  
    return MySwal.fire({ 
  
        title, 
        html, 
        icon, 
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',  
        showCancelButton: true, 
        cancelButtonColor: '#d33',  
        cancelButtonText: 'Cancelar' 
    }) 
}



export const VideosLista = () => {

    const { socket } = useContext( SocketContext );

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();
    
    const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario === null){
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate ])

    useHideMenu(false);
    

    const [ isLoading, setIsLoading ] = useState(false);
    
    // tabla
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    let   [sortedBy, setSortedBy] = useState('videoTitulo');
    let   [sortDirection, setSortDirection] = useState('asc');

    const datos={
        entidad,
        search : searchTerm || '',
        page: currentPage || '',
        itemsPerPage: itemsPerPage || '',
        sortedBy: sortedBy,
        sortDirection: sortDirection,
       
    }
    
    useEffect(() => {
        async function fetchData() {
            await socket.emit('videos-listas', datos, ( lista ) => {
                console.log(lista);
                setData( lista )
            })
        }

        fetchData();
        return () => {
            socket.off('videos-listas')
        }
    }, [socket])

    useEffect(() => {
      
        async function fetchData() {
            await socket.on('videos-listas', ( lista ) => {
                console.log(lista);
                setData( lista )
            })
        }

        fetchData();

        return () => {
            socket.off('videos-listas')
        }
    }, [socket])
   
    const handleSort = async (header) => {
        
        setSortedBy(header);
        const direction= sortDirection === 'asc' ? 'desc' : 'asc'
        setSortDirection( direction );
        datos.sortedBy= header;
        datos.sortDirection= direction;
        
        // setIsLoading(true)
        socket.emit( 'videos-listas', datos, async ( lista ) => {
            setData(lista);
            setIsLoading(false)
        })
           
        
    }
    
   
    

    const inactivaVideo = async (uidVideo, accion) => {
        console.log( uidVideo )
        
        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la infromación', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la infromación', 'error');

        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Eliminar el registro?", "warning" );
        if (!confirmacion.value) return false;

        datos.uidVideo= uidVideo;
        datos.accion= accion;
        
        // setIsLoading(true)
        socket.emit( 'inactiva-Video', datos, ( res ) => {
            console.log( res )
            setIsLoading(false)
        })

    }
  
    const registraVideo = async ( ) => {

        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la información', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la información', 'error');

        
        datos.videoCodigo   = document.getElementById(`videoCodigo_`).value;
        datos.videoTitulo   = document.getElementById(`videoTitulo_`).value;
        datos.videoOrden    = document.getElementById(`videoOrden_`).value;
        
        const registros = document.querySelectorAll('.registro');
        
        registros.forEach((elemento, index) => {
            if( elemento.value === "" ) return sweet('Atención!', 'Revise la información', 'error');
            if( elemento.value < 0    ) return sweet('Atención!', 'Revise la información', 'error');
        });

        
        setIsLoading(true)
        socket.emit( 'registra-Video', datos, async ( res ) => {
            setIsLoading(false)

            if( res[0] === ""){
                sweet('Atención!', res[1], 'error');
            }else if( res[0] === 1){
                sweet('', res[1], 'success');
                
                registros.forEach((elemento, index) => {
                    if( elemento.type !== "checkbox" ) elemento.value = ""
                    else elemento.checked= false;
                    delete datos[elemento.id.split("_")[0]];
                })   
            }else{
                console.log(res);
            }

          

        })

        

    }

    const editaVideo = async ( ev, uidVideo) =>{

        const campo= ev.target.id.split("_")[0];
        const valor= ev.target.value;
        const valorAnterior=  ev.target.defaultValue;

   
        

        if ( valor !== valorAnterior || ev.target.type === 'checkbox' ){

            const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Modificar el registro?", "warning" );
            if (!confirmacion.value){
                ev.target.value = valorAnterior;
                return false;
            }
            
            

            datos.campo = campo;
            datos.valor = valor;
            datos.uidVideo = uidVideo;

            setIsLoading(true)
            socket.emit( 'edita-Video', datos, async ( res ) => {
                console.log(res);
                setIsLoading(false)
                
                if( res === null){
                    
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    ev.target.value = valorAnterior;

                }else if( res[0] === ""){
                    
                    sweet('Atención!', res[1], 'error');
                    ev.target.value = valorAnterior;

                }else if( res[0] === 1){
                    
                    delete datos[campo];
                    delete datos[valor];
                    delete datos[uidVideo];
                                           
                }else{
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    console.log(res);
                }
    
            })

        }

        
    }
    
    // **************************table
    useEffect(() => {
        
        console.log(datos)
        // setIsLoading(true)
        socket.emit( 'videos-listas', datos, async ( lista ) => {
            console.log(lista)
            setIsLoading(false)
            setData(lista);
        })
        
    }, [searchTerm, currentPage, itemsPerPage]);
   


    
    const handleSearch = (ev) => {
        setSearchTerm(ev.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // const indexOfLastItem = currentPage * itemsPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(0, itemsPerPage);

   
    if( usuario.uidUsuario === null ) {
        return(
            <>
            </>
        )
    }
    else if( !pantallas.includes("videoslistas") ) {
        return( <NoAcceso /> )
    } 
    else{

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vh'}}>
                  
                    <div>

                        <div className='row'>
                            

                            <div className='col-lg-2 col-12 '>
                                <button
                                    className='btn btn-success m-3'
                                    data-bs-toggle="collapse" 
                                    data-bs-target="#divAgregaVideo"
                                >
                                Agregar Video
                                </button> 
                                
                            </div>
                        </div>

                        <div id='divAgregaVideo'  className='row border border-info rounded shadow p-3 collapse hide'>
                            <Table responsive="md" striped hover style={{minWidth: 300}} className='max400' >
                                <thead>
                                    <tr >
                                        <th width={'5%'}></th>
                                        <th width={'5%'}>Orden</th>
                                        <th width={'40%'}>Título</th>
                                        <th width={'50%'}>Código</th>
                                        
                                    </tr>
                                </thead>
                                <tbody   >
            
                                    <tr style={{minHeight: 150}}>
                                        <td width={'5%'}>
                                            <button
                                                className='btn btn-sm btn-primary me-1'
                                                onClick={ ()=> registraVideo() }
                                            > 
                                            <i className='fas fa-save'></i>
                                            </button> 

                                        </td>

                                        <td width={'5'}> 
                                            <input
                                                type='text'
                                                className='form-control registro'
                                                id='videoOrden_'
                                            />

                                        </td>

                                        <td width={'40%'}> 
                                            <input
                                                type='text'
                                                className='form-control registro'
                                                id='videoTitulo_'
                                            />

                                        </td>


                                        <td width={'50%'}> 
                                            <input
                                                type='text'
                                                className='form-control registro'
                                                id='videoCodigo_'
                                            />
                                        </td>
                                        
                                        
                                    </tr>
                                
                                </tbody>
                            </Table>

                        </div>

                        <hr />

                        

                        <div className='row rounded shadow p-3'>

                            <div className='col-12'>
                                <div className='float-start col-lg-4 col-12 pagination'>
                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                    {"<"}
                                    </button> 
                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={currentItems.length < itemsPerPage}
                                    >
                                    {">"}
                                    </button>
                                </div>
                        
                                <div className=' float-end col-lg-4 col-12'>

                                    <input
                                        type='text'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        maxLength={20}
                                        defaultValue={searchTerm}
                                        onChange={ (ev) => handleSearch(ev)}
                                    />

                                </div>
                            
                            </div>

                            <div className='col-12'>
                                <Table responsive="md" striped hover style={{minWidth: 600}} className='max400'>
                                    <thead>
                                        <tr>
                                            <th width={'5%'}></th>
                                            <th width={'5%'} onClick={ () => handleSort('orden') } >
                                                Orden
                                                {sortedBy === 'orden' && sortDirection === 'asc' && '▲'}
                                                {sortedBy === 'orden' && sortDirection === 'desc' && '▼'}
                                            </th>
                                            <th width={'20%'} onClick={ () => handleSort('videoTitulo') } >
                                                Titulo
                                                {sortedBy === 'videoTitulo' && sortDirection === 'asc' && '▲'}
                                                {sortedBy === 'videoTitulo' && sortDirection === 'desc' && '▼'}
                                            </th>
                                            <th width={'70%'} onClick={ () => handleSort('videoCodigo') } >
                                                Codigo
                                                {sortedBy === 'videoCodigo' && sortDirection === 'asc' && '▲'}
                                                {sortedBy === 'videoCodigo' && sortDirection === 'desc' && '▼'}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody width={'100%'}  >
                
                                    {
                                        
                                        currentItems.length === 0 
                                        ?   (   <tr>
                                                    <td width={'100%'} style= {{textAlign:'center'}}> No Hay Registros </td>
                                                </tr>
                                            )
                                        : 
                                        currentItems.map((item) => (

                                            <tr key={item.uidVideo}>
                                                <td width={'5%'}>
                                                
                                                    {   (item.indActivo=== 1) 
                                                        ?(
                                                            <button
                                                                className='btn btn-sm btn-danger'
                                                                onClick={() => inactivaVideo( item.uidVideo, 0 ) }
                                                            > 
                                                            <i className='fa-solid fa-minus'></i>
                                                            </button>
                                                        )
                                                        :(
                                                            <button
                                                                className='btn btn-sm btn-success'
                                                                onClick={() => inactivaVideo( item.uidVideo, 1 ) }
                                                            > 
                                                            <i className='fa-solid fa-plus'></i>
                                                            </button>
                                                        )
                                                    
                                                    }
                                                    


                                                </td>

                                                <td width={'5%'}> 
                                                    {/* {item.orden} */}
                                                    { 
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            id={`orden_${item.uidVideo}`}
                                                            defaultValue={item.orden}
                                                            maxLength={3}
                                                            onBlur={ (ev) => editaVideo( ev, item.uidVideo )}
                                                            // onChange={ (ev) => pasarMayusculas( ev )}
                                                        />
                                                    }
                                                    
                                                </td>

                                                <td width={'20%'}> 
                                                    {/* {item.videoTitulo.toUpperCase()} */}
                                                    {

                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            id={`videoTitulo_${item.uidVideo}`}
                                                            defaultValue={item.videoTitulo.toUpperCase()}
                                                            maxLength={100}
                                                            onBlur={ (ev) => editaVideo( ev, item.uidVideo )}
                                                            onChange={ (ev) => pasarMayusculas( ev )}
                                                        />
                                                    }
                                                    
                                                </td>
                                                <td width={'70%'}> 
                                                    {/* {item.videoCodigo.toUpperCase()} */}
                                                    {

                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            id={`videoCodigo_${item.uidVideo}`}
                                                            defaultValue={item.videoCodigo}
                                                            // defaultValue={item.videoCodigo.toUpperCase()}
                                                            maxLength={100}
                                                            onBlur={ (ev) => editaVideo( ev, item.uidVideo )}
                                                            // onChange={ (ev) => pasarMayusculas( ev )}
                                                        />
                                                    }
                                               </td>
                                                
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>

                            <div className='pagination'>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                {'<'}
                                </button> 
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={currentItems.length < itemsPerPage}
                                >
                                {'>'}
                                </button>
                            </div>
                            
                        </div>
                        
                                    
                    </div>
        
                    

                </div>    
            </>
        )
    }
}
